"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultContactAgentState = void 0;
var EnquireApiToken_1 = require("@/api/remote/protected/EnquireApiToken");
var EnquireState_init_1 = require("@/pages/common/states/EnquireState.init");
var SavedResultItem_init_1 = require("@/pages/search/states/SavedResultItem.init");
exports.defaultContactAgentState = {
    contactType: EnquireApiToken_1.EnquireRequestType.General,
    background: './res/img/masked.jpg',
    isLoading: EnquireState_init_1.defaultEnquireState.isLoading,
    enquiry: EnquireState_init_1.defaultEnquireForm,
    tForm: EnquireState_init_1.defaultEnquireState.tForm,
    salutations: EnquireState_init_1.defaultEnquireState.salutations,
    favorites: [SavedResultItem_init_1.defaultSavedResultItem1, SavedResultItem_init_1.defaultSavedResultItem2],
    favoritesInt: [SavedResultItem_init_1.defaultSavedResultItem2, SavedResultItem_init_1.defaultSavedResultItem1],
    t: {
        nameContactAgent: EnquireState_init_1.defaultEnquireState.t.nameContactAgent,
        nameContactCaption: EnquireState_init_1.defaultEnquireState.t.nameContactCaption,
        nameFavorite: EnquireState_init_1.defaultEnquireState.t.nameFavorite,
        nameFavoriteInt: EnquireState_init_1.defaultEnquireState.t.nameFavoriteInt,
        nameUnavailable: EnquireState_init_1.defaultEnquireState.t.nameUnavailable,
        namePrivacyPolicy: EnquireState_init_1.defaultEnquireState.t.namePrivacyPolicy,
        openGoogleMap: 'Open in Google Map',
        branches: 'Branches',
        location: 'Location',
    },
};
